'use client';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { formatName } from '../../util/formatters/format-name.js';
import { Popover } from '../popover/popover.js';
import { ProfileImageStack } from '../profile-image/profile-image-stack.js';
import 'react';
import '../../util/formatters/format-date.js';
import 'date-fns';
import 'date-fns/locale';
import '../../util/datetime/constants.js';
import '../../util/datetime/comparators.js';
import '../../types/order.js';
import '../../types/category.js';
import 'lodash.isempty';
import 'lodash.isnil';
import 'lodash.omitby';
import 'framer-motion';

const FeaturedCoaches = ({ className, coaches, featuredText, outlineColorClass, dark, }) => {
    if (!coaches.length)
        return null;
    const coachesToDisplay = coaches.slice(0, 3);
    const moreCoaches = coaches.slice(3);
    return (jsxs("div", { className: `flex items-center justify-start ${className}`, children: [jsx("div", { className: "sm:hidden", children: jsx(ProfileImageStack, { className: "mr-3 shrink-0", profiles: coachesToDisplay, outlineColorClass: outlineColorClass
                        ? outlineColorClass
                        : 'outline-leland-purple-light' }) }), jsx("p", { className: `shrink text-base font-normal ${dark ? 'text-white/70' : 'text-leland-gray-light'}`, children: featuredText ? (featuredText) : (jsxs(Fragment, { children: ["Featuring", ' ', coachesToDisplay.map((coach, i) => (jsxs("span", { children: [coachesToDisplay.length > 1 &&
                                    i === coachesToDisplay.length - 1
                                    ? 'and '
                                    : '', jsx("a", { href: coach.url, className: "underline", target: "_blank", rel: "noopener noreferrer", children: formatName({
                                        firstName: coach.firstName,
                                        lastName: coach.lastName,
                                    }) }), i === coachesToDisplay.length - 1
                                    ? ''
                                    : coachesToDisplay.length > 2
                                        ? ', '
                                        : ' '] }, coach.id))), moreCoaches.length > 0 ? (jsxs(Fragment, { children: [", and", ' ', jsxs(Popover, { content: moreCoaches.map(({ firstName, lastName }, idx) => (jsx("p", { children: formatName({ firstName, lastName }) }, idx))), children: [moreCoaches.length, " more"] })] })) : null] })) }), jsxs("div", { className: "ml-3 hidden items-center justify-center sm:flex", children: [jsx(ProfileImageStack, { profiles: coachesToDisplay, outlineColorClass: outlineColorClass
                            ? outlineColorClass
                            : 'outline-leland-purple-light' }), moreCoaches.length > 0 ? (jsx(Popover, { content: moreCoaches.map(({ firstName, lastName }, idx) => (jsx("p", { children: formatName({ firstName, lastName }) }, idx))), children: jsx("div", { className: `relative -ml-2 flex size-5 shrink-0 items-center justify-center rounded-full bg-leland-gray-dark outline outline-1 ${outlineColorClass
                                ? outlineColorClass
                                : 'outline-leland-purple-light'}`, children: jsxs("p", { className: "mb-0.5 mr-0.5 text-sm font-medium text-white", children: ["+", moreCoaches.length] }) }) })) : null] })] }));
};

export { FeaturedCoaches };
//# sourceMappingURL=featured-coaches.js.map
